var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ButtonV,{staticClass:"right-block__show-tours-button",class:{'right-block__show-tours-button_hotel-offer': _setup.isHotelOfferProductType},attrs:{"size":"medium"},on:{"click":($event) => _vm.$emit('go-to-target-page-button-click', $event)}},[_vm._v("\n    "+_vm._s(_setup.showToursButtonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }